module.exports = __webpack_public_path__ + "static/rainier-headshot-047e8eb47de7f1364471861d488ce5d3.jpg";